import type { DateTimeFormats } from '@intlify/core-base';

const dateTime: DateTimeFormats = {
	nl: {
		short: {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
		},
		long: {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		},
	},
};

export default dateTime;
